import './component';
import './preview';

Shopware.Service('cmsService').registerCmsBlock({
    name: 'acris-blog-product-slider',
    label: 'acris-blog.blocks.blogProductSlider.label',
    category: 'acris-blog',
    component: 'sw-cms-block-acris-blog-product-slider',
    previewComponent: 'sw-cms-preview-acris-blog-product-slider',
    defaultConfig: {
        marginBottom: '20px',
        marginTop: '20px',
        marginLeft: null,
        marginRight: null,
        sizingMode: 'boxed'
    },
    slots: {
        column: {
            type: 'acris-blog-product-slider'
        },
    }
});
